export default "./assets/a18f60c5d87dd02c.mp3"